import { combineReducers } from 'redux';
import announcementManagement from '../screens/AnnouncementManagement/reducers/';
import departmentAnnouncement from '../screens/DepartmentAnnouncement/reducers/';
export default combineReducers({
  announcementManagement,
  departmentAnnouncement,
});



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/DepartmentNews/reducers/index.js
 **/